import { Link } from 'react-router-dom';
import usePageMeta from '../components/usePageMeta';

function NotFound() {
  usePageMeta('Page Not Found', 'The page you are looking for could not be found.');

  return (
    <section className="not-found">
      <div className="container">
        <span className="eyebrow">404</span>
        <h1>Page not found</h1>
        <p>The page you're looking for doesn't exist or may have moved.</p>
        <Link to="/" className="btn btn-primary">
          Back to home
        </Link>
      </div>
    </section>
  );
}

export default NotFound;
